import Mediospago from './MediosPago';
import { SIZE } from './constants';

export default Mediospago;
export { SIZE };